export const JOB_CHAPTER_MODES = ['regular', 'climax', 'thematic', 'volume_opening', 'volume_finale'] as const

export type JobChapterMode = (typeof JOB_CHAPTER_MODES)[number]
